import { Section, H2, P, Callout } from "./Primitives";
import { Phone } from "../app-preview/Frames";
import { APP_SCREENS } from "../app-preview/AppScreens";
import { PortalMock, quote } from "../app-preview/PortalMock";
import { AppDemo } from "../app-preview/AppDemo";

const AppSlide = ({ s, n }) => (
  <div className="slide avoid-break" data-testid={`slide-app-${s.key}`}>
    <Phone><s.C /></Phone>
    <div className="mt-5">
      <div className="kicker">Slide {n}</div>
      <div className="font-display text-xl text-navy mt-1">{s.title}</div>
      <div className="text-sm text-[var(--ink-soft)] leading-relaxed mt-1">{s.text}</div>
    </div>
  </div>
);

export const AppPreview = () => {
  const lux = quote("luxury", 120, true);
  return (
    <Section id="anteprima" num="03" kicker="Anteprima dell'esperienza" title="Come saranno l'App e il Portale">
      <P>
        Le schermate che seguono mostrano come clienti e aziende vivranno Bella Napoli in digitale.
        La grafica riprende <strong>le stesse tonalità del marchio</strong>: crema, blu notte e oro. Così il negozio, il packaging e il telefono raccontano la stessa maison.
      </P>
      <AppDemo />
      <H2>App Clienti: le schermate principali</H2>
      <div className="grid sm:grid-cols-2 gap-x-8 gap-y-12 mb-6">
        {APP_SCREENS.map((s, i) => <AppSlide key={s.key} s={s} n={i + 1} />)}
      </div>
      <div className="keep">
        <H2>Portale Aziende: il preventivo istantaneo</H2>
        <P>
          Un responsabile HR configura il regalo per il proprio team in meno di due minuti e vede il prezzo finale prima di confermare. Due esempi:
        </P>
        <div className="avoid-break mb-3" data-testid="slide-portal-premium">
          <div className="kicker mb-2">Slide 5 · Studio professionale, 40 dipendenti, cesto Premium con logo</div>
          <PortalMock tier="premium" qty={40} logo />
        </div>
      </div>
      <div className="avoid-break mt-8 mb-6" data-testid="slide-portal-luxury">
        <div className="kicker mb-2">Slide 6 · Azienda, 120 dipendenti, cesto Luxury con sconto volume</div>
        <PortalMock tier="luxury" qty={120} logo company="Industrie Picentine S.p.A." />
      </div>
      <Callout title="Perché conta per il conto economico">
        Il preventivo che l'azienda vede è già quello definitivo. Il team commerciale non perde ore in richiami e trattative, e il laboratorio conosce le quantità con settimane d'anticipo.
        Un solo ordine come quello della slide 6 vale <strong>€ {Math.round(lux.total).toLocaleString("it-IT", { useGrouping: "always" })}</strong> IVA esclusa.
      </Callout>
      <p className="text-xs italic text-[var(--ink-soft)] mt-4">
        Le schermate sono rappresentazioni illustrative. Nomi, prezzi e grafica definitiva saranno concordati con Bella Napoli in fase di avvio.
      </p>
    </Section>
  );
};
